import { z } from 'zod'

export const schema = z.object({
  nearbyZones: z.array(
    z.object({
      url: z.string(),
      name: z.string(),
    }),
  ),
  nearbyVillages: z.array(
    z.object({
      url: z.string(),
      name: z.string(),
    }),
  ),
  nearbyCorners: z.array(
    z.object({
      url: z.string(),
      name: z.string(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
